import { useState } from 'react';

export default function EditCategoryModal({ category, onClose, onSave }) {
  const [formData, setFormData] = useState({
  name: category.name,
  description: category.description || '',
  image: null
});
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'Category name is required';
    }

    if (!formData.image.trim()) {
      newErrors.image = 'Image URL is required';
    } else if (!formData.image.match(/^https?:\/\/.+/)) {
      newErrors.image = 'Please enter a valid URL';
    }

    if (!formData.link.trim()) {
      newErrors.link = 'Link path is required';
    } else if (!formData.link.startsWith('/')) {
      newErrors.link = 'Link path must start with /';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
  e.preventDefault();

  if (!formData.name.trim()) return;

  const payload = new FormData();
  payload.append("name", formData.name);
  payload.append("description", formData.description);

  if (formData.image) {
    payload.append("image", formData.image);
  }

  onSave(category._id, payload);
};


  const handleChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 bg-white border-b border-gray-100 px-6 py-4 flex items-center justify-between">
          <div>
            <h2 className="text-xl font-bold text-gray-800">Edit Category</h2>
            <p className="text-sm text-gray-500 mt-1">Update category details</p>
          </div>
          <button
            onClick={onClose}
            className="w-10 h-10 flex items-center justify-center rounded-lg hover:bg-gray-100 transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-2xl text-gray-600"></i>
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6">
          <div className="space-y-5">
            {/* Category ID */}
            <div className="bg-gray-50 rounded-lg p-3 flex items-center gap-2">
              <i className="ri-hashtag text-gray-400"></i>
              <span className="text-sm text-gray-600">Category ID: <strong>{category._id}</strong></span>
            </div>

            {/* Category Name */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Category Name *
              </label>
              <input
                type="text"
                value={formData.name}
                onChange={(e) => handleChange('name', e.target.value)}
                placeholder="e.g., Dresses, Tops, Accessories"
                className={`w-full px-4 py-2.5 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-lilac-400 ${
                  errors.name ? 'border-red-500' : 'border-gray-200'
                }`}
              />
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">{errors.name}</p>
              )}
            </div>

            {/* Image File */}
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Image File *
              </label>
              <input
              type="file"
              accept="image/*"
              onChange={(e) => handleChange('image', e.target.files[0])}
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm"
              />
              {errors.image && (
                <p className="text-red-500 text-xs mt-1">{errors.image}</p>
              )}
              
              {/* Image Preview */}
              {formData.image && !errors.image && (
                <div className="mt-3 rounded-lg overflow-hidden border border-gray-200">
                  <div className="aspect-video w-full h-48 bg-gray-100 flex items-center justify-center">
                    <img
                      src={formData.image}
                      alt="Preview"
                      className="w-full h-full object-cover"
                      onError={(e) => {
                        e.currentTarget.style.display = 'none';
                        e.currentTarget.parentElement.innerHTML = '<div class="text-gray-400 text-sm">Failed to load image</div>';
                      }}
                    />
                  </div>
                </div>
              )}
            </div>

            <textarea
            value={formData.description}
            onChange={(e) => handleChange('description', e.target.value)}
            rows={3}
            className="w-full px-4 py-2.5 border border-gray-200 rounded-lg text-sm"
            />
          </div>

          {/* Actions */}
          <div className="flex gap-3 mt-8 pt-6 border-t border-gray-100">
            <button
              type="button"
              onClick={onClose}
              className="flex-1 px-6 py-2.5 border border-gray-200 text-gray-700 rounded-lg text-sm font-medium hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="flex-1 px-6 py-2.5 bg-lilac-400 text-white rounded-lg text-sm font-medium hover:bg-[#d94d87] transition-colors cursor-pointer whitespace-nowrap"
            >
              Save Changes
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
